module.exports = __webpack_public_path__ + "static/img/icon-search-history.b2d6cd3.png";